'use strict';
var $ = require('../internals/export');
var forEach = require('../internals/array-for-each');

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.array.for-each.js
// module id = 1056
// module chunks = 0